import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ToasterService {
    constructor(
        private toastr: ToastrService,
        private translate: TranslateService
    ) { }

    showSuccess(message: string, title: string = '', duration: number = 3000) {
        this.toastr.success(
            this.translate.instant(message),
            title ? this.translate.instant(title) : '',
            {
                timeOut: duration,
                positionClass: 'toast-bottom-right',
                closeButton: true,
                progressBar: true
            }
        );
    }

    showError(message: string, title: string = '', duration: number = 3000) {
        this.toastr.error(
            this.translate.instant(message),
            title ? this.translate.instant(title) : '',
            {
                timeOut: duration,
                positionClass: 'toast-bottom-right',
                closeButton: true,
                progressBar: true
            }
        );
    }

    showWarning(message: string, title: string = '', duration: number = 3000) {
        this.toastr.warning(
            this.translate.instant(message),
            title ? this.translate.instant(title) : '',
            {
                timeOut: duration,
                positionClass: 'toast-bottom-right',
                closeButton: true,
                progressBar: true
            }
        );
    }

    showInfo(message: string, title: string = '', duration: number = 3000) {
        this.toastr.info(
            this.translate.instant(message),
            title ? this.translate.instant(title) : '',
            {
                timeOut: duration,
                positionClass: 'toast-bottom-right',
                closeButton: true,
                progressBar: true
            }
        );
    }
}
